import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import Input from '../Common/Input';


const Form = ({ formik, activeList, businessList, isEditMode, modeShow,
    setModeShow, }) => {

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">

                {isEditMode === false && <div className="col-md-3">
                    <label > کسب و کار </label>
                    <ReactSelect
                        required
                        placeholder="انتخاب کنید"
                        options={businessList.filter(item => item.isActive === true)}
                        name="businessId"
                        isSearchable={true}
                        value={formik.values.businessId}
                        isRtl={true}
                        onChange={value => formik.setFieldValue("businessId", value)}
                        noOptionsMessage={() => 'نام مورد نظر یافت نشد'}
                    />
                </div>}

                <div className="col-md-3">
                    <Input label="عنوان" name="title" formik={formik} required={true} />
                </div>

                {/*        {isEditMode === false && <div className="col-md-3">
                    <label >فعال؟</label>
                    <ReactSelect
                        required
                        placeholder="انتخاب کنید"
                        options={activeList}
                        name="activeId"
                        isSearchable={true}
                        value={formik.values.activeId}
                        isRtl={true}
                        onChange={value => formik.setFieldValue("activeId", value)}
                        noOptionsMessage={() => 'نام مورد نظر یافت نشد'}
                    />
                </div>} */}

            </div>

            <div className='mx-auto text-center my-4 py-4'>
                <button className="btn btn-success">ذخیره اطلاعات</button>
            </div>

        </form>
    );
}

export default Form;
